import React from 'react';
import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import Label from '@discover-ui/label';
import { ToggleGroup, ToggleGroupItem } from '@discover-ui/toggleGroup';

export default function ModeToggles() {
  const mode = useStoreState((state) => state.mode);
  const setMode = useStoreActions((state) => state.setMode);

  return (
    <>
      <Label className="m-0 ml-auto">Mode</Label>
      <ToggleGroup
        type="single"
        value={mode || 'undefined'}
        onValueChange={(newMode) => {
          if (newMode === 'single' || newMode === 'list') {
            setMode(newMode);
          }
          if (newMode === 'undefined') {
            setMode(undefined);
          }
        }}
        className="gap-0">
        <ToggleGroupItem
          value="undefined"
          aria-label="Toggle Undefined"
          className="rounded-r-none p-2 outline-0">
          <Label className="m-0 text-xs">Undef</Label>
        </ToggleGroupItem>
        <ToggleGroupItem
          value="single"
          aria-label="Toggle Single"
          className="rounded-none p-2 outline-0">
          <Label className="m-0 text-xs">Single</Label>
        </ToggleGroupItem>
        <ToggleGroupItem
          value="list"
          aria-label="Toggle List"
          className="rounded-l-none p-2 outline-0">
          <Label className="m-0 text-xs">List</Label>
        </ToggleGroupItem>
      </ToggleGroup>
    </>
  );
}
